class EdgePromotionsCarousel {
  constructor(element) {
    this.element = element;
    this.cards = [...element.querySelectorAll("[data-edge-carousel-card]")];
    this.previousButton = element.querySelector("[data-edge-carousel-prev]");
    this.nextButton = element.querySelector("[data-edge-carousel-next]");
    this.activeIndex = this.cards.findIndex(
      (card) => card.dataset.edgePosition === "center",
    );
    this.touchStartX = 0;

    if (this.activeIndex < 0) this.activeIndex = 0;
    this.bindEvents();
    this.update();
  }

  bindEvents() {
    this.previousButton?.addEventListener("click", () => this.move(-1));
    this.nextButton?.addEventListener("click", () => this.move(1));

    this.cards.forEach((card, index) => {
      card.addEventListener("click", (event) => {
        if (event.target.closest(".edge-promotions-page__product-button")) {
          return;
        }
        if (index === this.activeIndex) return;
        this.activeIndex = index;
        this.update();
      });
    });

    this.element.addEventListener(
      "touchstart",
      (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX ?? 0;
      },
      { passive: true },
    );

    this.element.addEventListener(
      "touchend",
      (event) => {
        const touchEndX = event.changedTouches[0]?.clientX ?? 0;
        const distance = touchEndX - this.touchStartX;

        if (Math.abs(distance) < 40) return;
        this.move(distance < 0 ? 1 : -1);
      },
      { passive: true },
    );
  }

  move(direction) {
    this.activeIndex =
      (this.activeIndex + direction + this.cards.length) % this.cards.length;
    this.update();
  }

  update() {
    const lastIndex = this.cards.length - 1;

    this.cards.forEach((card, index) => {
      const offset =
        (index - this.activeIndex + this.cards.length) % this.cards.length;
      let position = "right";

      if (offset === 0) position = "center";
      if (offset === lastIndex) position = "left";

      card.dataset.edgePosition = position;
      card.querySelectorAll(".edge-promotions-page__product-button").forEach(
        (button) => {
          button.tabIndex = position === "center" ? 0 : -1;
        },
      );
    });
  }
}

document
  .querySelectorAll("[data-edge-promotions-carousel]")
  .forEach((element) => new EdgePromotionsCarousel(element));

document.querySelectorAll("[data-edge-product-dialog]").forEach((dialog) => {
  const openButton = document.querySelector("[data-edge-product-dialog-open]");
  const closeButton = dialog.querySelector("[data-edge-product-dialog-close]");

  openButton?.addEventListener("click", () => dialog.showModal());
  closeButton?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
});

const redMidSpark = document.querySelector(
  ".edge-promotions-page__mid-sparks-red",
);
const blueMidSpark = document.querySelector(
  ".edge-promotions-page__mid-sparks-blue",
);

const revealElements = document.querySelectorAll("[data-edge-scroll-reveal]");
const delayedRevealElements = document.querySelectorAll(
  "[data-edge-scroll-reveal-delayed]",
);

if ("IntersectionObserver" in window) {
  const observeRevealElements = (elements, rootMargin = "0px") => {
    const observer = new IntersectionObserver(
      (entries, revealObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("is-visible");
          if (entry.target.matches(".edge-promotions-page__probe-copy")) {
            window.setTimeout(() => redMidSpark?.classList.add("is-visible"), 40);
          }
          if (entry.target.matches(".edge-promotions-page__probe-art")) {
            window.setTimeout(() => blueMidSpark?.classList.add("is-visible"), 40);
          }
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin },
    );

    elements.forEach((element) => observer.observe(element));
  };

  const centerRevealMargin = "0px 0px -40% 0px";

  observeRevealElements(revealElements, centerRevealMargin);
  observeRevealElements(delayedRevealElements, centerRevealMargin);
} else {
  revealElements.forEach((element) => element.classList.add("is-visible"));
  delayedRevealElements.forEach((element) =>
    element.classList.add("is-visible"),
  );
  redMidSpark?.classList.add("is-visible");
  blueMidSpark?.classList.add("is-visible");
}
